"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mxp_schemas_1 = require("mxp-schemas");
class RichTextBlocks {
    static removeLineBreaks(html) {
        return html.replace(RichTextBlocks.LINE_BREAKS_REGEXP, '');
    }
    static prettifyHtml(html, isLocked = false) {
        // change line breaks to <br> and replace ALL not standard spaces with usual one
        return html.replace(RichTextBlocks.LINE_BREAKS_REGEXP, '<br>').replace(/\s/g, ' ');
    }
    static createFullWidthImage(node) {
        return RichTextBlocks.removeLineBreaks(`
		<div class="content-full-width-image">
			<div class="content-page-image-holder">
			<img src="${node.fields.image.fields.file.url}?${RichTextBlocks.IMAGE_CROPPING_SIZES.FULL_WIDTH_IMAGE}" alt="${node.fields.altText}">
			</div>
			${node.fields.caption ? `<div class="content-page-image-caption">${node.fields.caption}</div>` : ''}
			${node.fields.credit ? `<div class="content-page-image-credit">${node.fields.credit}</div>` : ''}
		</div>`);
    }
    static createInlineImage(node) {
        return RichTextBlocks.removeLineBreaks(`
		<div class="content-inline-image">
			<div class="content-page-image-holder">
			<img src="${node.fields.image.fields.file.url}?${RichTextBlocks.IMAGE_CROPPING_SIZES.INLINE_IMAGE}" alt="${node.fields.altText}">
			</div>
			${node.fields.caption ? `<div class="content-page-image-caption">${node.fields.caption}</div>` : ''}
			${node.fields.credit ? `<div class="content-page-image-credit">${node.fields.credit}</div>` : ''}
		</div>`);
    }
    static createPullQuote(node) {
        return RichTextBlocks.removeLineBreaks(`
		<blockquote>
			<q>
				${node.fields.pullQuote}
			</q>
			<cite>
				${node.fields.credit}
			</cite>
		</blockquote>`);
    }
    static createTable(node) {
        if (!node ||
            !node.fields ||
            !node.fields.tableField ||
            !node.fields.tableField.tableData ||
            !node.fields.tableField.tableData.length) {
            return;
        }
        let builtTable = RichTextBlocks.removeLineBreaks(`
      <div class="content-page-table-wrapper">
        <table class="content-page-table">
    `);
        node.fields.tableField.tableData.forEach((row, i) => {
            const cellElement = i === 0 ? 'th' : 'td';
            if (i === 0) {
                builtTable += '<thead>';
            }
            builtTable += '<tr>';
            row.forEach((element) => {
                builtTable += `<${cellElement}>${element || ''}</${cellElement}>`;
            });
            builtTable += '</tr>';
            if (i === 0) {
                builtTable += '</thead>';
            }
        });
        builtTable += '</tbody></table></div>';
        return builtTable;
    }
    static createGenericContentLink(node, isLocked = false, isAdvTable = false) {
        var _a, _b, _c, _d;
        const typeString = !isAdvTable
            ? node.data.target.sys.contentType.sys.id.replace('Template', '')
            : node.sys.contentType.sys.id.replace('Template', '');
        const contentTypeSlug = mxp_schemas_1.Content.typeList.includes(typeString)
            ? typeString
            : typeString === 'toolkitPage'
                ? 'toolkit'
                : mxp_schemas_1.Content.typeList[0];
        return isLocked
            ? node.content[0].value
            : isAdvTable
                ? `/${(_c = (_b = (_a = node.fields) === null || _a === void 0 ? void 0 : _a.contentCategory) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.slug}/${contentTypeSlug}/${(_d = node.fields) === null || _d === void 0 ? void 0 : _d.slug}`
                : `<a class="rich-text-internal-link" href="/${node.data.target.fields.contentCategory.fields.slug}/${contentTypeSlug}/${node.data.target.fields.slug}">${node.content[0].value}</a>`;
    }
    static createExternalArticleLink(node, isLocked = false, isAdvTable = false) {
        var _a;
        return isLocked
            ? node.content[0].value
            : isAdvTable
                ? `${(_a = node.fields) === null || _a === void 0 ? void 0 : _a.externalUrl}`
                : `<a class="rich-text-external-link" href="${node.data.target.fields.externalUrl}" target="_blank">${node.content[0].value}</a>`;
    }
    static createStaticArticleLink(node, isLocked = false, isAdvTable = false) {
        var _a;
        return isLocked
            ? node.content[0].value
            : isAdvTable
                ? `/${mxp_schemas_1.Content.CategorySlugs.HELP}/${(_a = node.fields) === null || _a === void 0 ? void 0 : _a.slug}`
                : `<a class="rich-text-internal-link" href="/${mxp_schemas_1.Content.CategorySlugs.HELP}/${node.data.target.fields.slug}">${node.content[0].value}</a>`;
    }
    static createCampaignLink(node) {
        var _a;
        return `/campaigns/${(_a = node.fields) === null || _a === void 0 ? void 0 : _a.slug}`;
    }
    static createTopicAggregationLink(node, isLocked = false, isAdvTable = false, isAccessNow) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (isLocked) {
            return node.content[0].value;
        }
        if (isAccessNow) {
            return `/topic/${(_a = node.fields) === null || _a === void 0 ? void 0 : _a.slug}`;
        }
        if (node.data.target.fields.level === 'level2') {
            // Level 2 topics are not displayed in our UI but we cannot prevent them being linked here
            // If one is linked and has a grandparent then we return a link to it's parent
            // added for generating link for advance table
            if (isAdvTable) {
                if (!node.fields.parent[0] || !node.fields.parent[0].fields.parent[0])
                    return;
                return `/topic/${(_f = (_e = (_d = (_c = (_b = node.fields) === null || _b === void 0 ? void 0 : _b.parent[0]) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.parent[0]) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.slug}/${(_g = node.fields) === null || _g === void 0 ? void 0 : _g.parent[0]}`;
            }
            if (!node.data.target.fields.parent[0] || !node.data.target.fields.parent[0].fields.parent[0])
                return;
            return `<a class="rich-text-internal-link" href="/topic/${node.data.target.fields.parent[0].fields.parent[0].fields.slug}/${node.data.target.fields.parent[0].fields.slug}">${node.content[0].value}</a>`;
        }
        // added for generating link for advance table
        if (isAdvTable) {
            return `/topic${((_h = node.fields) === null || _h === void 0 ? void 0 : _h.parent) && ((_j = node.fields) === null || _j === void 0 ? void 0 : _j.parent[0]) ? `/${(_m = (_l = (_k = node.fields) === null || _k === void 0 ? void 0 : _k.parent[0]) === null || _l === void 0 ? void 0 : _l.fields) === null || _m === void 0 ? void 0 : _m.slug}` : ''}/${(_o = node.fields) === null || _o === void 0 ? void 0 : _o.slug}`;
        }
        return `<a class="rich-text-internal-link" href="/topic${node.data.target.fields.parent && node.data.target.fields.parent[0]
            ? `/${node.data.target.fields.parent[0].fields.slug}`
            : ''}/${node.data.target.fields.slug}">${node.content[0].value}</a>`;
    }
    static createHyperlink(node, isLocked = false) {
        const externalLink = this.isExternal(node.data.uri);
        return isLocked
            ? node.content[0].value
            : externalLink
                ? `<a class="rich-text-external-link" href="${node.data.uri}" target="_blank">${node.content[0].value}</a>`
                : `<a class="rich-text-internal-link" href="${node.data.uri}">${node.content[0].value}</a>`;
    }
    static createAdvancedTable(node, links) {
        if (!node || !node.fields || !node.fields.tableMarkdown) {
            return;
        }
        // Will extract the markdown links included on the tablemarkdown
        const markDownLinks = node.fields.tableMarkdown.match(/\{{(.+?)\}}/g);
        let finalMarkDown = node.fields.tableMarkdown;
        markDownLinks === null || markDownLinks === void 0 ? void 0 : markDownLinks.forEach((mdLink) => {
            var _a;
            // getting the number from mark down
            // iterator cannot be used link number can sometimes be jumbled on creating tablemarkdown
            const generatedLink = (_a = links.find((link) => {
                const trimmedId = mdLink.replace('{{', '').replace('}}', '');
                return link.linkId.replace(/link/gi, 'Link ') === trimmedId;
            })) === null || _a === void 0 ? void 0 : _a.generatedLink;
            finalMarkDown = finalMarkDown.replace(mdLink, `(${generatedLink})`);
        });
        return finalMarkDown;
    }
}
RichTextBlocks.IMAGE_CROPPING_SIZES = {
    FULL_WIDTH_IMAGE: 'w=1000&h=1000',
    INLINE_IMAGE: 'w=600&h=400&fit=thumb',
};
RichTextBlocks.isExternal = (item) => {
    return Boolean(item === null || item === void 0 ? void 0 : item.startsWith('http'));
};
RichTextBlocks.LINE_BREAKS_REGEXP = /(?:\r\n|\r|\n)/g;
exports.default = RichTextBlocks;
//# sourceMappingURL=RichTextBlocks.js.map